import React from 'react'
let PropTypes = React.PropTypes
// API
import api from '../apiClient/v1'
// MOMENT
import moment from 'moment'
moment.locale('es')
// CSS
import * as css from '../auditorias/revision/PanelAuditoria.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)
// COMPONENTES
import BlackBoxPublicados from './programacion-semanal/BlackBoxIGSemanal.js'
import {InformativoPublicados} from './InformativoPublicados.jsx'
import  { TablaPublicadosCompleta } from './TablaPublicados.jsx'
import SelectRange from '../components/shared/SelectRangeVirtualTable.jsx'
// FORMAT FECHA
const format = 'YYYY-MM-DD'

export class ProgramacionPublicada extends React.Component {
    constructor(props) {
        super(props);
        this.blackbox = new BlackBoxPublicados()
        this.state = {
            idCliente: 0,
            filtros: {},
            inventariosFiltrados: [],
            fechaInicialSeleccionada: moment().subtract(1, 'days'),
            fechaFinalSeleccionada: moment().endOf('week'),
            totalUnidadesContar: 0,
            sobredotadas: 0,
            vacias: 0,
            peligro: 0,
            noInformadas: 0,
            totalInventarios: 0
        }
    }
    buscarInventarios = ()=>{
        let fechaInicio = this.state.fechaInicialSeleccionada.format(format)
        let fechaFin = this.state.fechaFinalSeleccionada.format(format)
        let idCliente = this.state.idCliente
        this.setState({inventariosFiltrados : [], totalUnidadesContar:0 , sobredotadas: 0, vacias: 0, peligro: 0, peligro: 0, noInformadas: 0, totalInventarios: 0})
        api.inventario.buscarResumido(fechaInicio, fechaFin, idCliente)
            .then(result=>{
                this.blackbox.reset()
                result.inventarios.forEach(inventario=>this.blackbox.add(inventario))
                this.blackbox.ordenarLista()
                this.setState(this.blackbox.getListaFiltrada())
                this.setState({sobredotadas: result.totalNominasSobreDotacion, vacias: result.totalNominasVacias, peligro: result.totalNominasPeligro,
                               noInformadas: result.totalNoInformadas, totalInventarios: result.totalInventarios, totalUnidadesContar: result.totalAcontar,
                               totalEnCambio: result.totalEnCambio})
            })
    }
    actualizarFiltro = (nombreFiltro, filtro) => {
        this.blackbox.reemplazarFiltro(nombreFiltro, filtro)
        this.setState(this.blackbox.getListaFiltrada())
    }
    onSelectRangoChanged = (momentumFechaInicio, momentumFechaFinal) =>{
        this.setState({
            fechaInicialSeleccionada: momentumFechaInicio,
            fechaFinalSeleccionada: momentumFechaFinal
        }, ()=>{
            this.buscarInventarios()

        })
    }
    onSelectClienteChanged = (evt) => {
        this.setState({
            idCliente: evt.target.value
        }, ()=>{
            this.buscarInventarios()
        })
    }
    componentWillMount() {
        this.buscarInventarios()
    }
    render() {
        return (
            <div className="container-fluid">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="page-header row">
                            <div className={cx("col-md-12", 'tituloAuditoria')}>
                                <div className={cx("col-md-3", 'divTitulo')}>
                                    <h3><span className='glyphicon glyphicon-certificate'></span> Inventarios publicados</h3>
                                </div>
                                <div className="col-md-6">
                                    <SelectorCliente
                                        onSelectClienteChanged = {this.onSelectClienteChanged}
                                        clientes = {this.props.clientes}
                                        idCliente = {this.state.idCliente}
                                    />
                                    <SelectorRango
                                        fechaInicial = {this.state.fechaInicialSeleccionada}
                                        fechaFinal = {this.state.fechaFinalSeleccionada}
                                        onSelectRangoChanged = {this.onSelectRangoChanged}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <ButtonShowChange
                                        totalEnCambio = {this.state.totalEnCambio}
                                    />
                                </div>
                            </div>
                        </div>
                        <InformativoPublicados
                            sobredotadas = {this.state.sobredotadas}
                            peligro = {this.state.peligro}
                            noInformadas = {this.state.noInformadas}
                            vacias = {this.state.vacias}
                            totalInventarios = {this.state.totalInventarios}
                            totalUnidadesContar = {this.state.totalUnidadesContar}
                        />
                        <TablaPublicadosCompleta
                            inventarios = {this.state.inventariosFiltrados}
                            filtros={this.state.filtros}
                            actualizarFiltro={this.actualizarFiltro.bind(this)}
                        />    
                    </div>
                </div>
            </div>
        )
    }
}
const SelectorRango = ({fechaInicial, fechaFinal, onSelectRangoChanged})=>
    <div className={cx("col-md-9",'divNavBar')}>
        <SelectRange
            startDateSelected = {fechaInicial}
            endDateSelected = {fechaFinal}
            onInit={()=>{console.log("on init")}}
            onRangeSelected = {onSelectRangoChanged.bind(this)}
        />
    </div>
const SelectorCliente = ({idCliente, clientes, onSelectClienteChanged})=>
    <div className={cx("col-md-3",'divNavBar')}>
        <select className="form-control"
                value={idCliente}
                onChange={onSelectClienteChanged.bind(this)}>
            <option value="0">Clientes</option>
            {clientes.map((cliente, index)=>{
                return <option key={index} value={cliente.idCliente}>{`${cliente.nombreCorto} - ${cliente.nombre}`}</option>
            })}
        </select>    
    </div>
const ButtonShowChange = ({totalEnCambio})=>
    <div className={cx("col-md-12",'divNavBar')}>
        <button className="btn btn-xs btn-info pull-right">
            <span className={'glyphicon glyphicon-th-list'}></span> En modificación <span className="badge">{totalEnCambio}</span>
        </button>
    </div>
            
        
    



// WEBPACK FOOTER //
// ./frontEnd/inventarios/ProgramacionPublicada.jsx